import { Component, OnInit } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { EventsService } from '../../core/services/events.service';
import { Constants, MENU_ITEM_LIST } from '../../core/config/Constants';
import { MenuItemService } from '../../core/services/menu-item.service';
import { MenuItems } from '../../core/models/menu-items';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.html',
  styleUrls: ['./left-menu.css'],
  providers: [MenuItemService, EventsService],
})
export class LeftMenuComponent implements OnInit {
  isShow: boolean;
  currentEventId: string;
  menuItemList: any[];

  showAdminControls: boolean = false;

  constructor(
    private menuItemService: MenuItemService,
    private extraService: ExtraService,
    private eventService: EventsService,
    private route: ActivatedRoute
  ) {}
  ngOnInit() {
    console.log('Left Menu');

    this.extraService.cast$.subscribe(isShow => {
      setTimeout(() => {
        this.isShow = isShow;
      });
    });
    this.extraService.castCurrentEventId$.subscribe(id => {
      this.currentEventId = id;
      this.addMenuItems();
    });

    this.route.queryParams.subscribe(params => {
      let eventId = params['eventId'];
      if(eventId){
        this.eventService.isEventEditor(eventId).then(isEditor => {
          if(isEditor) this.showAdminControls = false;
          else this.showAdminControls = true
        })
      }
    });
  }

  addMenuItems() {
    if (this.currentEventId) {
      this.menuItemService
        .getEventMenuItems(this.currentEventId)
        .snapshotChanges()
        .subscribe(list => {
          this.menuItemList = new Array();
          list.forEach(element => {
            let y = element.payload.toJSON() as MenuItems;
            let index = MENU_ITEM_LIST.findIndex(obj => {
              return obj.value == y.realName;
            });
            this.menuItemList.push(MENU_ITEM_LIST[index]);
          });
        });
    }
  }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/layout/left-menu/left-menu.component.ts